var React = require('react');

function Grid12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Property 1=Grid","fill":"currentColor"},[React.createElement("rect",{"id":"Rectangle 701","width":"5","height":"5","rx":"1","key":0}),React.createElement("rect",{"id":"Rectangle 702","x":"7","width":"5","height":"5","rx":"1","key":1}),React.createElement("rect",{"id":"Rectangle 703","x":"7","y":"7","width":"5","height":"5","rx":"1","key":2}),React.createElement("rect",{"id":"Rectangle 704","y":"7","width":"5","height":"5","rx":"1","key":3})]));
}

Grid12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Grid12x12;

Grid12x12.default = Grid12x12;
